import { ChangeEvent, Component, InputHTMLAttributes } from 'react';

import files from 'utils/files';

export type FileWithDimension = File & { dimensions?: { width: number, height: number } };

export type BraxUncontrolledFileFieldProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
    onUpload?: (files: FileWithDimension[]) => void
    onCancel?: () => void
};

export class BraxUncontrolledFileField extends Component<BraxUncontrolledFileFieldProps> {

    private ref: HTMLInputElement | null = null;

    public open = () => this.ref?.click();

    private selectFiles = async (event: ChangeEvent<HTMLInputElement>) => {
        this.props.onChange?.(event);

        this.props.onUpload?.(await Promise.all(Array.from(event.target.files!).map(
            async file => Object.assign(file, { dimensions: await this.getImageDimensions(file) }))
        ));

        // No React, os campos do tipo file sempre são não controlados
        // É necessário resetar seu valor após completar o evento para que o `onChange` seja chamado na próxima alteração
        event.target.value = '';
    }

    private async getImageDimensions(file: File) {
        if (!this.props.accept?.startsWith('image/'))
            return undefined;

        try {
            return await files.getImageSizes(file);
        } catch (error) {
            return undefined;
        }
    }

    private setRef = (ref: HTMLInputElement | null) => {
        this.ref?.removeEventListener('cancel', this.cancel);

        ref?.addEventListener('cancel', this.cancel);

        this.ref = ref;
    };

    private cancel = () => this.props.onCancel?.();

    render() {
        const { className, onChange, onUpload, ...props } = this.props;

        return (
            <input ref={this.setRef} type="file" className={`brax-file-field ${className}`} {...props} onChange={this.selectFiles} />
        );
    }

}
